// extracted by mini-css-extract-plugin
module.exports = {"varSpDown3":"0.25rem","varSpUp2":"1.5rem","poweredByLink":"poweredByLink--12a3a","poweredByText":"poweredByText--94095","hotelPlannerLogo":"hotelPlannerLogo--8ea95"};